import type { PageDrawer } from 'framework/ViewTypes';
import type { ApplicationRow } from '../types';
import { applicationDrawers } from '../useApplicationActions';
import type { ApplicationDrawerName } from '../useApplicationActions';
import ApplicationCandidateDecisionDrawer from './ApplicationCandidateDecisionDrawer';
import ApplicationChecklistReviewDrawer from './ApplicationChecklistReviewDrawer';
import ApplicationCreateOfferDrawer from './ApplicationCreateOfferDrawer';
import ApplicationDecisionDrawer from './ApplicationDecisionDrawer';
import ApplicationEditDrawer from './ApplicationEditDrawer';
import ApplicationInterviewResultsDrawer from './ApplicationInterviewResultsDrawer';
import ApplicationRejectCandidateDrawer from './ApplicationRejectCandidateDrawer';
import ApplicationScheduleInterviewDrawer from './ApplicationScheduleInterviewDrawer';

export type ApplicationDrawersProps = {
  application: Nullable<ApplicationRow>;
  openDrawer: Nullable<ApplicationDrawerName>;
  onClose: () => void;
};

export const getApplicationDrawers = ({ application, openDrawer, onClose }: ApplicationDrawersProps): PageDrawer[] => {
  if (!application) return [];

  return [
    <ApplicationDecisionDrawer
      key={applicationDrawers.decision}
      isOpen={openDrawer === applicationDrawers.decision}
      onClose={onClose}
    />,
    <ApplicationEditDrawer
      key={applicationDrawers.edit}
      isOpen={openDrawer === applicationDrawers.edit}
      onClose={onClose}
      application={application}
    />,
    <ApplicationChecklistReviewDrawer
      key={applicationDrawers.checklistReview}
      isOpen={openDrawer === applicationDrawers.checklistReview}
      onClose={onClose}
      applicationId={application.id}
    />,
    <ApplicationScheduleInterviewDrawer
      key={applicationDrawers.scheduleInterview}
      isOpen={openDrawer === applicationDrawers.scheduleInterview}
      onClose={onClose}
    />,
    <ApplicationInterviewResultsDrawer
      key={applicationDrawers.interviewResults}
      isOpen={openDrawer === applicationDrawers.interviewResults}
      onClose={onClose}
    />,
    <ApplicationCandidateDecisionDrawer
      key={applicationDrawers.candidateDecision}
      isOpen={openDrawer === applicationDrawers.candidateDecision}
      onClose={onClose}
    />,
    <ApplicationRejectCandidateDrawer
      key={applicationDrawers.rejectCandidate}
      isOpen={openDrawer === applicationDrawers.rejectCandidate}
      onClose={onClose}
    />,
    <ApplicationCreateOfferDrawer
      key={applicationDrawers.createOffer}
      isOpen={openDrawer === applicationDrawers.createOffer}
      onClose={onClose}
    />,
  ];
};
